/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import APIRequest from './index';

// pre,
export function getNodeStatus(res, order="desc") {
  return APIRequest('get', '/lora/network/node', { sort: res,order}, {}, null);
}

export function getGatewayStatus(res, order="desc") {
  return APIRequest('get', '/lora/network/gateway', { sort: res,order}, {}, null);
}


export function getGatewayNodeStatus(gateway,res, order="desc") {
  return APIRequest('get', '/lora/network/gateway/'+gateway, { sort: res,order}, {}, null);
}




// WEBPACK FOOTER //
// ./src/api/lora_network.js